export const MODULE_CONFIGS = {
  webPos: {
    title: 'Web POS',
    description: 'Employee sales terminal flow. All interactions are currently mocked end-to-end.',
    objects: ['Cart Session', 'Line Item', 'Discount', 'Tax Summary', 'Payment', 'Receipt', 'Adjustment Audit'],
    actions: ['Scan/Add Item', 'Apply Discount', 'Validate Stock', 'Take Payment', 'Finalize Sale', 'Admin-only Stock Adjustment'],
    workflows: ['Open Shift', 'Build Cart', 'Checkout', 'Post Transaction', 'Print/Send Receipt', 'Admin Adjustment Review'],
    apiEndpoints: ['/web-pos', '/web-pos/adjustments', '/inventory/site-stock', '/sites'],
  },
  sales: {
    title: 'Sales',
    description: 'Item-level sale deltas and transaction performance view, currently backed by mock data.',
    objects: ['Transaction', 'Sale Item Delta', 'Payment Record', 'Tax Detail', 'Sales Channel'],
    actions: ['Filter by Site', 'Filter by Date', 'Inspect Line Deltas', 'Export Results', 'Reconcile Totals'],
    workflows: ['Capture Sale', 'Compute Deltas', 'Aggregate Totals', 'Review Exceptions', 'Close Day'],
    apiEndpoints: ['/sales', '/sales/timeline'],
  },
  inventory: {
    title: 'Inventory',
    description: 'Master list of available stock and quantities across sites.',
    objects: ['Stock Item', 'Stock Ledger', 'Site Stock', 'Variant Stock', 'Adjustment', 'Unit of Measure'],
    actions: ['Receive Stock', 'Adjust Quantity', 'Transfer Site Stock', 'Track Localized Stock', 'View Stock Timeline', 'Track Piece-based Inventory'],
    workflows: ['Inbound Receipt', 'Site Allocation', 'Event Replenishment', 'Stock Depletion', 'Admin Adjustment'],
    apiEndpoints: ['/inventory', '/inventory/site-stock', '/inventory/uom', '/sites'],
  },
  products: {
    title: 'Products',
    description: 'Product definitions, required supplies, production yield, and production lead times.',
    objects: ['Product', 'Recipe Line', 'Yield Profile', 'Production Time', 'Variant', 'Percentage Mix'],
    actions: ['Create Product', 'Attach Recipe', 'Set Yield', 'Set Lead Time', 'Compute Cost from Recipe', 'Manage Variants'],
    workflows: ['Define Product', 'Build Recipe (Part A + Part B + Consumables)', 'Estimate Output', 'Compute Unit Cost'],
    apiEndpoints: ['/products', '/products/variants', '/products/recipes'],
  },
  supplies: {
    title: 'Supplies',
    description: 'Consumables and components including filament, keychains, keyrings, clasps, and machine-related supplies.',
    objects: ['Supply Item', 'Supply Purchase Order', 'Vendor', 'Unit Profile', 'Variant', 'Pack Size'],
    actions: ['Create Supply', 'Create Supply PO', 'Manage Vendor Dropdown List', 'Receive Supply', 'Track Grams/Packs', 'Define Units per Pack'],
    workflows: ['Procurement (Low Priority)', 'Vendor Selection', 'Receipt', 'Consumption', 'Replenishment'],
    apiEndpoints: ['/supplies', '/supplies/vendors', '/supplies/purchase-orders', '/supplies/uom'],
  },
  sites: {
    title: 'Sites',
    description: 'Site master and localized stock ownership. Events are mapped to sites and replenishment is site-based.',
    objects: ['Site', 'Site Inventory Snapshot', 'Event Mapping', 'Replenishment Record', 'Site Assignment'],
    actions: ['Create Site', 'Assign Event Site', 'View Site Stock', 'Replenish Site Stock', 'Transfer Between Sites'],
    workflows: ['Site Setup', 'Attach Site to Event', 'Load Event Stock', 'Run Event', 'Post-Event Replenishment'],
    apiEndpoints: ['/sites', '/inventory/site-stock'],
  },
  events: {
    title: 'Events',
    description: 'Event scheduling, creation, and editing with operational visibility.',
    objects: ['Event', 'Venue', 'Schedule Window', 'Assigned Team', 'Event Note'],
    actions: ['Create Event', 'Edit Event', 'Set Date Range', 'Assign Team', 'Publish Calendar'],
    workflows: ['Plan Event', 'Review Availability', 'Confirm Schedule', 'Run Event', 'Post Event Notes'],
    apiEndpoints: ['/events', '/events/sites', '/sites'],
  },
  crm: {
    title: 'CRM',
    description: 'Consignment agreements, remediation details, and relationship lifecycle tracking.',
    objects: ['Account', 'Consignment Agreement', 'Remediation Case', 'Contact', 'Interaction Log'],
    actions: ['Create Agreement', 'Track Commitments', 'Open Remediation', 'Log Follow-up', 'Close Case'],
    workflows: ['Onboard Account', 'Manage Agreement', 'Track Performance', 'Resolve Issues'],
    apiEndpoints: ['/crm/agreements', '/crm/remediations'],
  },
  employees: {
    title: 'Employees',
    description: 'Employee profile, remuneration, overtime, and workforce operations.',
    objects: ['Employee', 'Role', 'Shift', 'Payroll Entry', 'Overtime Request'],
    actions: ['Add Employee', 'Assign Role', 'Manage Shift', 'Record OT', 'Compute Payroll'],
    workflows: ['Hire', 'Schedule', 'Track Hours', 'Approve OT', 'Run Payroll'],
    apiEndpoints: ['/employees', '/employees/payroll', '/employees/overtime'],
  },
  reports: {
    title: 'Reports',
    description: 'Daily and weekly report generation for operational and financial insights.',
    objects: ['Report Template', 'Report Run', 'Report Filter', 'KPI Snapshot', 'Export Artifact'],
    actions: ['Select Template', 'Set Date Range', 'Generate Report', 'Export PDF/CSV', 'Share Report'],
    workflows: ['Collect Inputs', 'Generate Metrics', 'Review Output', 'Distribute Report'],
    apiEndpoints: ['/reports/templates', '/reports/runs', '/sales', '/sales/sites/site1/summary'],
  },
}
